import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname } = useLocation(); // Get current route

  useEffect(() => {
    // Automatically scroll to top on route change
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]); // Runs when the route changes

  useEffect(() => {
    // Show button when scrolled down 300px
    const toggleVisibility = () => {
      setIsVisible(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="scroll-to-top-btn"
          aria-label="Scroll to Top"
        >
          <i className="top fas fa-chevron-up"></i>
        </button>
      )}
    </div>
  );
}

export default ScrollToTop;
